import { useEffect, useState } from "react";
import api from "@/lib/api";

// Safe defaults until /api/config/flags resolves: hidden features stay hidden.
const DEFAULT_FLAGS = {
  school_reviews_enabled: false,
  standalone_forum_enabled: false,
  article_discussions_enabled: false,
  loaded: false,
};

let cache = null;
let inflight = null;

function loadFlags() {
  if (!inflight) {
    inflight = api
      .get("/config/flags")
      .then((r) => (cache = { ...DEFAULT_FLAGS, ...r.data, loaded: true }))
      .catch(() => { inflight = null; return { ...DEFAULT_FLAGS, loaded: true }; });
  }
  return inflight;
}

export function useFlags() {
  const [flags, setFlags] = useState(cache || DEFAULT_FLAGS);
  useEffect(() => {
    if (cache) return;
    let alive = true;
    loadFlags().then((f) => alive && setFlags(f));
    return () => { alive = false; };
  }, []);
  return flags;
}
